// extracted by mini-css-extract-plugin
export var actionButton = "_di-0";
export var attachmentLine = "_di-1";
export var fileInput = "_di-2";
export var fileUploadWrapper = "_di-4";
export var footer = "_di-3";
export var modalContent = "_di-5";
export var paperclip = "_di-6";
export var quillEditor = "_di-7";